import * as React from 'react';
import * as SliderPrimitive from './radix-ui-react-slider';
import { cn } from '@/utils';

function Slider({
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  step = 1,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
  const currentValues = (() => {
    if (Array.isArray(value)) return value;
    if (Array.isArray(defaultValue)) return defaultValue;
    return [min, max];
  })();

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      step={step}
      className={cn(
        `relative my-5 flex w-full touch-none select-none items-center data-[orientation=vertical]:h-full
        data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col
        data-[disabled]:opacity-50`,
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot="slider-track"
        className={cn(
          `relative grow overflow-hidden rounded-full bg-[#b3b3b3] data-[orientation=horizontal]:h-0.5
          data-[orientation=vertical]:h-full data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-1.5`,
        )}
      >
        <SliderPrimitive.Range
          data-slot="slider-range"
          className={cn('absolute bg-primary data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full')}
        />
      </SliderPrimitive.Track>

      {Array.from({ length: currentValues.length }, (_, index) => (
        <SliderPrimitive.Thumb
          data-slot="slider-thumb"
          key={index}
          className="focus-visible:outline-hidden block size-8 shrink-0 rounded-full border-2 border-[#b3b3b3] bg-background shadow-sm
            ring-ring/50 transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 disabled:pointer-events-none
            disabled:opacity-50"
        />
      ))}
    </SliderPrimitive.Root>
  );
}

export { Slider };
